import { studentMessagesRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const permission = [IRoleEnum.Student];

const studentMessagesRouteMetadata: IRouteMetadataObj<
  typeof studentMessagesRoutesObj
> = {
  list: {
    title: "studentMessages.index.title",
    description: "studentMessages.index.description",
    lazy: () => import("@/pages/studentPages/messages/table/page"),
    mode: "index",
    type: "main",
    icon: "BookLine",
    breadcrumbs: [],
    permission,
  },
  create: {
    title: "messages.create.title",
    description: "messages.create.description",
    lazy: () => import("@/pages/studentPages/messages/form/page"),
    mode: "create",
    type: "inner",
    icon: "AddLine",
    breadcrumbs: [],
    permission,
  },
};

export const studentMessagesRoutes = createRoute<
  typeof studentMessagesRoutesObj
>(studentMessagesRoutesObj, studentMessagesRouteMetadata);
